var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-tag',{staticClass:"manifestacao-situacao-badge",attrs:{"type":_vm.tipo}},[_vm._v(" "+_vm._s(_vm.rotulo)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }